/*
 * The audit log and the outbox lists, a page at a time.
 */
import { z } from "zod";

/** One page of a list, with the cursor for the next page (null on the last page). */
export const pageOf = <T extends z.ZodType>(item: T) => z.object({ items: z.array(item), next: z.string().nullable() });

export const auditItem = z.object({
  id: z.uuid(),
  action: z.string(),
  userId: z.uuid().nullable(),
  /** The login's name, or null for the system (timers, the copy script). */
  userName: z.string().nullable(),
  subjectType: z.string().nullable(),
  subjectId: z.uuid().nullable(),
  ip: z.string().nullable(),
  details: z.record(z.string(), z.unknown()),
  createdAt: z.string(),
});
export const outboxItem = z.object({
  id: z.uuid(),
  channel: z.string(),
  purpose: z.string(),
  to: z.string(),
  subject: z.string().nullable(),
  body: z.string(),
  template: z.string(),
  status: z.string(),
  sendAfter: z.string(),
  error: z.string().nullable(),
  createdAt: z.string(),
});

/** Settings > Recently deleted: what was removed in the last 30 days and can still be put back. */
export const deletedItem = z.object({
  kind: z.enum(["note", "file", "request"]),
  id: z.uuid(),
  /** The note's first words, the file's name, or the request's name. */
  title: z.string(),
  /** Where it was: client, job or visit (notes and files), request. */
  on: z.enum(["client", "job", "visit", "request"]),
  onId: z.uuid(),
  deletedAt: z.string(),
});
export type DeletedItem = z.infer<typeof deletedItem>;
export const deletedList = z.object({ items: z.array(deletedItem) });
export type DeletedList = z.infer<typeof deletedList>;
